import * as format from 'string-template';
import { getGlobalConfig } from './common';
var GLOBAL_MESSAGE_KEY = 'MESSAGE';
/**
 * 从全局变量中获取字符串，并做变量替换，得到最终字符串
 *
 * 如 text('a.b.c', 1, 2) 并且 window.G_GOV_MESSAGE['a.b.c'] 是 "{0} + {1} = 3"，
 * 结果是 "1 + 2 = 3"
 */

export function text(key) {
  var messages = getGlobalConfig(GLOBAL_MESSAGE_KEY);
  if (!messages) return '';
  var str = messages[key];
  if (!str) return '';

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return format.apply(void 0, [str].concat(args));
}
export { format };